// [dialCode, minDigits, maxDigits]
export const countryCodes = {
  "Afghanistan": ["+93", 9, 9],
  "Albania": ["+355", 9, 9],
  "Algeria": ["+213", 9, 9],
  "Andorra": ["+376", 6, 9],
  "Angola": ["+244", 9, 9],
  "Antigua and Barbuda": ["+1", 10, 10],
  "Argentina": ["+54", 10, 11],
  "Armenia": ["+374", 8, 8],
  "Australia": ["+61", 9, 9],
  "Austria": ["+43", 10, 13],
  "Azerbaijan": ["+994", 9, 9],
  "Bahamas": ["+1", 10, 10],
  "Bahrain": ["+973", 8, 8],
  "Bangladesh": ["+880", 10, 10],
  "Barbados": ["+1", 10, 10],
  "Belarus": ["+375", 9, 9],
  "Belgium": ["+32", 9, 9],
  "Belize": ["+501", 7, 7],
  "Benin": ["+229", 8, 8],
  "Bhutan": ["+975", 8, 8],
  "Bolivia": ["+591", 8, 8],
  "Bosnia and Herzegovina": ["+387", 8, 8],
  "Botswana": ["+267", 7, 8],
  "Brazil": ["+55", 10, 11],
  "Brunei": ["+673", 7, 7],
  "Bulgaria": ["+359", 9, 9],
  "Burkina Faso": ["+226", 8, 8],
  "Burundi": ["+257", 8, 8],
  "Cabo Verde": ["+238", 7, 7],
  "Cambodia": ["+855", 8, 9],
  "Cameroon": ["+237", 9, 9],
  "Canada": ["+1", 10, 10],
  "Central African Republic": ["+236", 8, 8],
  "Chad": ["+235", 8, 8],
  "Chile": ["+56", 9, 9],
  "China": ["+86", 11, 11],
  "Colombia": ["+57", 10, 10],
  "Comoros": ["+269", 7, 7],
  "Congo": ["+242", 9, 9],
  "Costa Rica": ["+506", 8, 8],
  "Croatia": ["+385", 8, 9],
  "Cuba": ["+53", 8, 8],
  "Cyprus": ["+357", 8, 8],
  "Czech Republic": ["+420", 9, 9],
  "Denmark": ["+45", 8, 8],
  "Djibouti": ["+253", 8, 8],
  "Dominica": ["+1", 10, 10],
  "Dominican Republic": ["+1", 10, 10],
  "Ecuador": ["+593", 9, 9],
  "Egypt": ["+20", 10, 10],
  "El Salvador": ["+503", 8, 8],
  "Equatorial Guinea": ["+240", 9, 9],
  "Eritrea": ["+291", 7, 7],
  "Estonia": ["+372", 7, 8],
  "Eswatini": ["+268", 8, 8],
  "Ethiopia": ["+251", 9, 9],
  "Fiji": ["+679", 7, 7],
  "Finland": ["+358", 9, 10],
  "France": ["+33", 9, 9],
  "Gabon": ["+241", 7, 8],
  "Gambia": ["+220", 7, 7],
  "Georgia": ["+995", 9, 9],
  "Germany": ["+49", 10, 12],
  "Ghana": ["+233", 9, 9],
  "Greece": ["+30", 10, 10],
  "Grenada": ["+1", 10, 10],
  "Guatemala": ["+502", 8, 8],
  "Guinea": ["+224", 9, 9],
  "Guinea-Bissau": ["+245", 9, 9],
  "Guyana": ["+592", 7, 7],
  "Haiti": ["+509", 8, 8],
  "Honduras": ["+504", 8, 8],
  "Hungary": ["+36", 9, 9],
  "Iceland": ["+354", 7, 9],
  "India": ["+91", 10, 10],
  "Indonesia": ["+62", 9, 12],
  "Iran": ["+98", 10, 10],
  "Iraq": ["+964", 10, 10],
  "Ireland": ["+353", 9, 9],
  "Israel": ["+972", 9, 9],
  "Italy": ["+39", 9, 10],
  "Jamaica": ["+1", 10, 10],
  "Japan": ["+81", 10, 11],
  "Jordan": ["+962", 9, 9],
  "Kazakhstan": ["+7", 10, 10],
  "Kenya": ["+254", 9, 10],
  "Kiribati": ["+686", 5, 8],
  "Kuwait": ["+965", 8, 8],
  "Kyrgyzstan": ["+996", 9, 9],
  "Laos": ["+856", 8, 9],
  "Latvia": ["+371", 8, 8],
  "Lebanon": ["+961", 7, 8],
  "Lesotho": ["+266", 8, 8],
  "Liberia": ["+231", 7, 8],
  "Libya": ["+218", 9, 9],
  "Liechtenstein": ["+423", 7, 9],
  "Lithuania": ["+370", 8, 8],
  "Luxembourg": ["+352", 9, 9],
  "Madagascar": ["+261", 9, 9],
  "Malawi": ["+265", 9, 9],
  "Malaysia": ["+60", 9, 10],
  "Maldives": ["+960", 7, 7],
  "Mali": ["+223", 8, 8],
  "Malta": ["+356", 8, 8],
  "Marshall Islands": ["+692", 7, 7],
  "Mauritania": ["+222", 8, 8],
  "Mauritius": ["+230", 8, 8],
  "Mexico": ["+52", 10, 10],
  "Micronesia": ["+691", 7, 7],
  "Moldova": ["+373", 8, 8],
  "Monaco": ["+377", 8, 9],
  "Mongolia": ["+976", 8, 8],
  "Montenegro": ["+382", 8, 8],
  "Morocco": ["+212", 9, 9],
  "Mozambique": ["+258", 9, 9],
  "Myanmar": ["+95", 8, 9],
  "Namibia": ["+264", 9, 9],
  "Nauru": ["+674", 7, 7],
  "Nepal": ["+977", 10, 10],
  "Netherlands": ["+31", 9, 9],
  "New Zealand": ["+64", 8, 10],
  "Nicaragua": ["+505", 8, 8],
  "Niger": ["+227", 8, 8],
  "Nigeria": ["+234", 8, 10],
  "North Korea": ["+850", 9, 10],
  "North Macedonia": ["+389", 8, 8],
  "Norway": ["+47", 8, 8],
  "Oman": ["+968", 8, 8],
  "Pakistan": ["+92", 10, 10],
  "Palau": ["+680", 7, 7],
  "Panama": ["+507", 8, 8],
  "Papua New Guinea": ["+675", 7, 8],
  "Paraguay": ["+595", 9, 9],
  "Peru": ["+51", 9, 9],
  "Philippines": ["+63", 10, 10],
  "Poland": ["+48", 9, 9],
  "Portugal": ["+351", 9, 9],
  "Qatar": ["+974", 8, 8],
  "Romania": ["+40", 9, 9],
  "Russia": ["+7", 10, 10],
  "Rwanda": ["+250", 9, 9],
  "Saint Kitts and Nevis": ["+1", 10, 10],
  "Saint Lucia": ["+1", 10, 10],
  "Saint Vincent and the Grenadines": ["+1", 10, 10],
  "Samoa": ["+685", 5, 7],
  "San Marino": ["+378", 8, 10],
  "Sao Tome and Principe": ["+239", 7, 7],
  "Saudi Arabia": ["+966", 9, 9],
  "Senegal": ["+221", 9, 9],
  "Serbia": ["+381", 8, 9],
  "Seychelles": ["+248", 7, 7],
  "Sierra Leone": ["+232", 8, 8],
  "Singapore": ["+65", 8, 8],
  "Slovakia": ["+421", 9, 9],
  "Slovenia": ["+386", 8, 8],
  "Solomon Islands": ["+677", 5, 7],
  "Somalia": ["+252", 7, 9],
  "South Africa": ["+27", 9, 9],
  "South Korea": ["+82", 9, 11],
  "South Sudan": ["+211", 9, 9],
  "Spain": ["+34", 9, 9],
  "Sri Lanka": ["+94", 9, 9],
  "Sudan": ["+249", 9, 9],
  "Suriname": ["+597", 6, 7],
  "Sweden": ["+46", 9, 10],
  "Switzerland": ["+41", 9, 9],
  "Syria": ["+963", 9, 9],
  "Taiwan": ["+886", 9, 10],
  "Tajikistan": ["+992", 9, 9],
  "Tanzania": ["+255", 9, 9],
  "Thailand": ["+66", 9, 9],
  "Timor-Leste": ["+670", 7, 8],
  "Togo": ["+228", 8, 8],
  "Tonga": ["+676", 5, 7],
  "Trinidad and Tobago": ["+1", 10, 10],
  "Tunisia": ["+216", 8, 8],
  "Turkey": ["+90", 10, 10],
  "Turkmenistan": ["+993", 8, 8],
  "Tuvalu": ["+688", 5, 6],
  "Uganda": ["+256", 9, 9],
  "Ukraine": ["+380", 9, 9],
  "United Arab Emirates": ["+971", 9, 9],
  "United Kingdom": ["+44", 10, 10],
  "United States": ["+1", 10, 10],
  "Uruguay": ["+598", 8, 9],
  "Uzbekistan": ["+998", 9, 9],
  "Vanuatu": ["+678", 5, 7],
  "Vatican City": ["+379", 8, 10],
  "Venezuela": ["+58", 10, 10],
  "Vietnam": ["+84", 9, 10],
  "Yemen": ["+967", 9, 9],
  "Zambia": ["+260", 9, 9],
  "Zimbabwe": ["+263", 9, 9]
};
